import TextArea from './TextArea';
import { withFormMeta } from '../../FormMeta';
import styles from './TextArea.module.scss';
import { wrapInLabel } from '../NewInputLabelWrapper';

export default withFormMeta(wrapInLabel(TextArea, { disabled: styles.disabled, error: styles.error }));
